/* eslint-disable react/jsx-no-target-blank */
import useB4BreakPoints from "hooks/useB4BreakPoints";
import { TabPanel, TabView } from "primereact/tabview";
import React, { useEffect, useState } from "react";
import { OpcionesPlanes } from "./opciones";
import "./styles.scss";

const requiredMessage = "Este campo es obligatorio";

const DatosGenerales = ({ catalogo = {}, handleRegresar = () => {} }) => {
  const { inSm, inXs, inMd, inLg, inXl } = useB4BreakPoints();
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {}, [catalogo]);

  const setTabMargin = () => {
    if (inXs) {
      return "2rem";
    }

    if (inSm) {
      return "10rem";
    }

    if (inMd) {
      return "15rem";
    }

    if (inLg) {
      return "20rem";
    }
    if (inXl) {
      return "23rem";
    }
  };
  console.log("CATALOGO: ", catalogo);
  return (
    <React.Fragment>
      <TabView
        className='my-5'
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
        style={{ borderColor: "#ff3" }}>
        {catalogo?.paquetes?.map((item, i) => (
          <TabPanel
            key={`tbcob${i}`}
            headerStyle={{
              marginLeft: i === 0 && setTabMargin(),
              fontSize: "20px",
            }}
            header={<h1 style={{ fontSize: "25px" }}>{item?.producto ?? ""}</h1>}
            contentStyle={{ margin: "0 0 0 0", padding: "0 0 0 0" }}>
            <OpcionesPlanes
              name='coberturas.planSeleccionado'
              rules={{ required: requiredMessage }}
              opciones={item?.planes}
              exclusiones={catalogo?.exclusiones}
            />
          </TabPanel>
        ))}
      </TabView>
      <div className='row justify-content-center my-5'>
        <div className='col-11 col-sm-5 col-md-3 col-xl-2'>
          <button className='btn btn-atras-api' onClick={handleRegresar}>
            Atrás
          </button>
        </div>
        <div className='col-11 col-sm-5  col-md-3 col-xl-2'>
          <button className='btn btn-siguiente-api' type='submit'>
            Continuar
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DatosGenerales;
